module.exports = __webpack_public_path__ + "static/media/Dream_mobile_on_AE_EN.0febd966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dream_mobile_on_AE_EN.png
// module id = 553
// module chunks = 0